import ResourceComponent from '../../../common/ResourceComponent';
import {Button, Col, FormGroup, Label, Row, Spinner} from 'reactstrap';
import Slider from '../../../common/Slider';
import Select from 'react-select';
import {embFilterStyle} from '../../../common/SelectStyles';
import React, {createRef} from 'react';
import moment from 'moment';
import {MEDIUM_SCREEN_WIDTH, MOBILE_SCREEN_WIDTH, SMALL_MOBILE_SCREEN_WIDTH} from '../../../common/MobileUtils';
import PropTypes from 'prop-types';
import {bindActionCreators} from 'redux';
import * as actions from '../EmbeddableApi';
import {connect} from 'react-redux';
import _ from 'lodash';
import {getBackgroundColor, reverseColor} from '../../../common/Utils';

class EmbFilters extends ResourceComponent {
    state = {
        slab_slider: {
            price: {min: 0, max: 0},
            width_minimum: {min: 0, max: 0},
            width_maximum: {min: 0, max: 0},
            length: {min: 0, max: 0},
            surfaced_thickness: {min: 0, max: 0},
        },
        lumber_slider: {
            price: {min: 0, max: 0},
            width: {min: 0, max: 0},
            length: {min: 0, max: 0},
            surfaced_thickness: {min: 0, max: 0},
        },
        bundle_slider: {
            price: {min: 0, max: 0},
            rows: {min: 0, max: 0},
            avg_board_length: {min: 0, max: 0},
            thickness: {min: 0, max: 0},
            total_bf: {min: 0, max: 0},
        },
        industrial_pack_slider: {
            price: {min: 0, max: 0},
            avg_board_length: {min: 0, max: 0},
            thickness: {min: 0, max: 0},
            available_bf: {min: 0, max: 0},
        },
        industrial_pack_mass_timber_slider: {
            price: {min: 0, max: 0},
            board_length: {min: 0, max: 0},
            thickness: {min: 0, max: 0},
            actual_thickness: {min: 0, max: 0},
            available_bf: {min: 0, max: 0},
        },
        resource: {
            item_type: {},
            number: [],
            characters: [],
            species: [],
            categories: [],
            tags: [],
            locations: [],
            cycles: [],
            trees: [],
            price: {
                min: 0,
                max: 0,
            },
            width_minimum: {
                min: 0,
                max: 0,
            },
            width_maximum: {
                min: 0,
                max: 0,
            },
            length: {
                min: 0,
                max: 0,
            },
            surfaced_thickness: {
                min: 0,
                max: 0,
            },
            thickness: {
                min: 0,
                max: 0,
            },
            actual_thickness: {
                min: 0,
                max: 0,
            },
            total_bf: {
                min: 0,
                max: 0,
            },
            available_bf: {
                min: 0,
                max: 0,
            },
            avg_board_length: {
                min: 0,
                max: 0,
            },
            board_length: {
                min: 0,
                max: 0,
            },
            width: {
                min: 0,
                max: 0,
            },
        },
        advancedFilters: false,
        resetSliderTime: moment(),
        numbers: [],
        characters: [],
        species: [],
        thicks: [],
        categories: [],
        tags: [],
        locations: [],
        cycles: [],
        gradings: [],
        ready: false,
        filter: false,
        reset: false,
    };

    componentDidMount() {
        this.reloadFilters();

        this.skuRef = createRef();
        this.charactersRef = createRef();
        this.categoryRef = createRef();
        this.statusRef = createRef();
        this.locationRef = createRef();
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevState.thicks.length && prevState.thicks.length !== this.state.thicks.length) {
            this.props.actions.loadFilters(this.props.filters.type, this.props.filter_id, filters => {
                switch (this.props.filters.type) {
                    case 'slabs': {
                        const {slab_slider} = this.state;
                        const newSlabSlider = {...slab_slider, ...filters};
                        this.setState({slab_slider: newSlabSlider, ready: true});
                        break;
                    }
                    case 'lumbers': {
                        const {lumber_slider} = this.state;
                        const newLumberSlider = {...lumber_slider, ...filters};
                        this.setState({lumber_slider: newLumberSlider, ready: true});
                        break;
                    }
                    case 'bundles': {
                        const {bundle_slider} = this.state;
                        const newBundleSlider = {...bundle_slider, ...filters};
                        this.setState({bundle_slider: newBundleSlider, ready: true});
                        break;
                    }
                    case 'industrial_packs': {
                        const {industrial_pack_slider} = this.state;
                        const newIndustrialPackSlider = {...industrial_pack_slider, ...filters};
                        this.setState({industrial_pack_slider: newIndustrialPackSlider, ready: true});
                        break;
                    }
                    case 'industrial_packs_mass_timber': {
                        const {industrial_pack_mass_timber_slider} = this.state;
                        const newIndustrialPackSlider = {...industrial_pack_mass_timber_slider, ...filters};
                        this.setState({industrial_pack_mass_timber_slider: newIndustrialPackSlider, ready: true});
                        break;
                    }
                    default:
                        break;
                }
            });
        }

        const filters = document.getElementsByClassName('filters')[0];
        filters.addEventListener('scroll', () => {
            this.skuRef.current && this.skuRef.current.blur();
            this.charactersRef.current && this.charactersRef.current.blur();
            this.categoryRef.current && this.categoryRef.current.blur();
            this.statusRef.current && this.statusRef.current.blur();
        });
        filters.removeEventListener('scroll', () => {
        });
        if (!_.isEqual(prevProps.characters, this.props.characters)) {
            this.loadCharacters();
        }
        if (!_.isEqual(prevProps.categories, this.props.categories)) {
            this.loadCategories();
        }
        if (!_.isEqual(prevProps.tags, this.props.tags)) {
            this.loadTags();
        }
        if (!_.isEqual(prevProps.locations, this.props.locations)) {
            this.loadLocations();
        }
        if (!_.isEqual(prevProps.cycles, this.props.cycles)) {
            this.loadCycles();
        }
        if (!_.isEqual(prevProps.gradings, this.props.gradings)) {
            this.setGradings();
        }
    }

    reloadFilters = () => {
        this.setState({
            resource: {
                ...this.state.resource,
                item_type: {value: this.props.filters.type, label: this.props.filters.type},
            },
        });
        this.delayedSearch = _.debounce(() => this.onSliderChange(), 500);
        this.loadNumbers();
        this.loadCharacters();
        this.loadSpecies();
        this.loadCategories();
        this.loadTags();
        this.loadLocations();
        this.loadCycles();
        this.setGradings();
        this.setThicks();
    };

    prepareThickIds = (resource = null) => {
        const {thicks} = this.state;
        const thick_ids = thicks.filter(t => {
            return resource.thickness.min ? parseFloat(t.thickness) >= parseFloat(resource.thickness.min) : true;
        }).filter(t => {
            return resource.thickness.max ? parseFloat(t.thickness) <= parseFloat(resource.thickness.max) : true;
        }).map(t => t.id);

        return (thicks && thick_ids && thicks.length !== thick_ids.length) ? thick_ids : [];
    };

    prepareActualThickIds = (resource = null) => {
        const {thicks} = this.state;
        const thick_ids = thicks.filter(t => {
            return resource.actual_thickness.min ? parseFloat(t.thickness) >= parseFloat(resource.actual_thickness.min) : true;
        }).filter(t => {
            return resource.actual_thickness.max ? parseFloat(t.thickness) <= parseFloat(resource.actual_thickness.max) : true;
        }).map(t => t.id);

        return (thicks && thick_ids && thicks.length !== thick_ids.length) ? thick_ids : [];
    };

    prepareParams = (resource = null) => {
        const {item_type} = this.state.resource;
        let params = {...resource};
        const itemType = item_type.value ? item_type.value : this.props.filters.type;

        params.number = resource.number;
        params.character_ids = resource.characters.map(n => n.value);
        params.species_ids = resource.species.map(n => n.value);
        params.category_ids = resource.categories.map(n => n.value);
        params.tag_ids = resource.tags.map(n => n.value);
        params.location_ids = resource.locations.map(n => n.value);
        params.cycle_ids = resource.cycles.map(n => n.value);
        if (itemType !== 'slabs' && itemType !== 'lumbers') {
            params.thick_ids = this.prepareThickIds(resource);
            if (itemType === 'industrial_packs_mass_timber') {
                params.actual_thickness_ids = this.prepareActualThickIds(resource);
            }
        }
        params.type = itemType;
        if (resource.gradings) {
            params.grading_ids = resource.gradings.map(n => n.value);
        }

        return params;
    };

    setItemTypeOptions = () => {
        const {settings} = this.props;
        const isIndustrialPackMassTimberEnabled = this.props.profile.feature_flags.find(ff => ff.name === 'Industrial Packs - Mass Timber');
        const itemTypeOptions = [];
        if (settings.embed_slabs_length > 0) {
            itemTypeOptions.push({value: 'slabs', label: 'Slabs'});
        }
        if (settings.embed_lumbers_length > 0) {
            itemTypeOptions.push({value: 'lumbers', label: 'Boards and Beams'});
        }
        if (settings.embed_bundles_length > 0) {
            itemTypeOptions.push({value: 'bundles', label: 'Packs'});
        }
        if (settings.embed_industrial_packs_length > 0) {
            itemTypeOptions.push({value: 'industrial_packs', label: 'Industrial Packs'});

            if (isIndustrialPackMassTimberEnabled) {
                itemTypeOptions.push({value: 'industrial_packs_mass_timber', label: 'Industrial Packs Mass Timber'});
            }
        }
        return itemTypeOptions;
    };

    getInitialResource = (itemType = this.props.filters.type, sliderRanges) => {
        const {
            slab_slider,
            lumber_slider,
            bundle_slider,
            industrial_pack_slider,
            industrial_pack_mass_timber_slider,
        } = this.state;
        switch (itemType) {
            case 'slabs': {
                const slider = sliderRanges || slab_slider;
                return {
                    item_type: this.setItemTypeOptions().find(it => it.value === itemType),
                    type: itemType,
                    number: null,
                    characters: [],
                    trees: [],
                    species: [],
                    locations: [],
                    cycles: [],
                    categories: [],
                    tags: [],
                    price: {min: 0, max: slider.price ? slider.price.max : 0},
                    width_minimum: {min: 0, max: slider.width_minimum ? slider.width_minimum.min : 0},
                    width_maximum: {min: 0, max: slider.width_maximum ? slider.width_maximum.max : 0},
                    surfaced_thickness: {
                        min: 0,
                        max: slider.surfaced_thickness ? slider.surfaced_thickness.max : 0,
                    },
                    length: {min: 0, max: slider.length ? slider.length.max : 0},
                };
            }
            case 'lumbers': {
                const slider = sliderRanges || lumber_slider;
                return {
                    item_type: this.setItemTypeOptions().find(it => it.value === itemType),
                    type: itemType,
                    number: null,
                    characters: [],
                    trees: [],
                    species: [],
                    locations: [],
                    cycles: [],
                    categories: [],
                    tags: [],
                    price: {min: 0, max: slider.price ? slider.price.max : 0},
                    width: {min: 0, max: slider.width ? slider.width.min : 0},
                    surfaced_thickness: {
                        min: 0,
                        max: slider.surfaced_thickness ? slider.surfaced_thickness.max : 0,
                    },
                    length: {min: 0, max: slider.length ? slider.length.max : 0},
                };
            }
            case 'bundles': {
                const slider = sliderRanges || bundle_slider;
                return {
                    item_type: this.setItemTypeOptions().find(it => it.value === itemType),
                    type: itemType,
                    number: null,
                    characters: [],
                    trees: [],
                    species: [],
                    locations: [],
                    cycles: [],
                    categories: [],
                    tags: [],
                    price: {min: 0, max: slider.price ? slider.price.max : 0},
                    thickness: {min: 0, max: slider.thickness ? slider.thickness.max : 0},
                    avg_board_length: {
                        min: 0,
                        max: slider.avg_board_length ? slider.avg_board_length.max : 0,
                    },
                    total_bf: {min: 0, max: slider.total_bf ? slider.total_bf.max : 0},
                    rows: {min: 0, max: slider.rows ? slider.rows.max : 0},
                };
            }
            case 'industrial_packs': {
                const slider = sliderRanges || industrial_pack_slider;
                return {
                    item_type: this.setItemTypeOptions().find(it => it.value === itemType),
                    type: itemType,
                    number: null,
                    characters: [],
                    trees: [],
                    species: [],
                    locations: [],
                    cycles: [],
                    gradings: [],
                    categories: [],
                    tags: [],
                    price: {min: 0, max: slider.price ? slider.price.max : 0},
                    avg_board_length: {
                        min: 0,
                        max: slider.avg_board_length ? slider.avg_board_length.max : 0,
                    },
                    thickness: {
                        min: 0,
                        max: slider.thickness ? slider.thickness.max : 0,
                    },
                    available_bf: {
                        min: 0,
                        max: slider.available_bf ? slider.available_bf.max : 0,
                    },
                    rows: {min: 0, max: slider.rows ? slider.rows.max : 0},
                };
            }
            case 'industrial_packs_mass_timber': {
                const slider = sliderRanges || industrial_pack_mass_timber_slider;
                return {
                    item_type: this.setItemTypeOptions().find(it => it.value === itemType),
                    type: itemType,
                    number: null,
                    characters: [],
                    trees: [],
                    species: [],
                    locations: [],
                    cycles: [],
                    gradings: [],
                    categories: [],
                    tags: [],
                    price: {min: 0, max: slider.price ? slider.price.max : 0},
                    board_length: {
                        min: 0,
                        max: slider.board_length ? slider.board_length.max : 0,
                    },
                    thickness: {
                        min: 0,
                        max: slider.thickness ? slider.thickness.max : 0,
                    },
                    actual_thickness: {
                        min: 0,
                        max: slider.actual_thickness ? slider.actual_thickness.max : 0,
                    },
                    available_bf: {
                        min: 0,
                        max: slider.available_bf ? slider.available_bf.max : 0,
                    },
                    rows: {min: 0, max: slider.rows ? slider.rows.max : 0},
                };
            }
            default:
                return null;
        }
    };

    resetFilters = () => {
        const {resource} = this.state;
        const itemType = resource.item_type.value;
        this.props.actions.loadFilters(itemType, this.props.filter_id, filterRanges => {
            const initialFilters = this.getInitialResource(itemType, filterRanges);
            const filtersAfterReset = {...initialFilters, ...filterRanges, type: resource.item_type.value};
            switch (resource.item_type.value) {
                case 'slabs': {
                    this.setState({slab_slider: filterRanges});
                    break;
                }
                case 'lumbers': {
                    this.setState({lumber_slider: filterRanges});
                    break;
                }
                case 'bundles': {
                    this.setState({bundle_slider: filterRanges});
                    break;
                }
                case 'industrial_packs': {
                    this.setState({industrial_pack_slider: filterRanges});
                    break;
                }
                default:
                    break;
            }
            this.setState(
                {resource: filtersAfterReset, reset: true, resetSliderTime: moment()},
                () => this.props.onFilterSelect(filtersAfterReset, () => this.setState({reset: false})),
            );
        });

    };

    onFilterSelect = (field, newValue) => {
        const {filters, onFilterSelect} = this.props;
        const newFilters = {...filters, [field]: newValue};
        return onFilterSelect(newFilters);
    };

    onSliderChange = () => {
        const {onSliderChange} = this.props;
        const {resource} = this.state;
        const filters = _.omit(resource, ['number', 'characters', 'species', 'categories', 'locations', 'cycles', 'tags', 'gradings']);
        if (filters.type !== 'slabs' && filters.type !== 'lumbers') {
            filters.thick_ids = this.prepareThickIds(resource);

            if (filters.type === 'industrial_packs_mass_timber') {
                filters.actual_thickness_ids = this.prepareActualThickIds(resource);
            }
        }
        return onSliderChange(filters);
    };

    loadNumbers = (q = '') => {
        const params = this.prepareParams(this.state.resource);
        params.tree_ids = this.state.resource.tree_ids;
        params.filter_id = this.props.filter_id;
        this.props.actions.searchNumbers(q, result => this.setState({numbers: result}), params);
    };

    loadCharacters = (q = '') => {
        const {characters} = this.props;
        const params = this.prepareParams(this.state.resource);
        if (characters) {
            this.setState({characters});
        } else {
            this.props.actions.searchCharacters(q, result => this.setState({characters: result}), params);
        }
    };

    loadSpecies = (q = '') => {
        const params = this.prepareParams(this.state.resource);
        params.filter_id = this.props.filter_id;
        this.props.actions.searchSpecies(q, result => {
            this.setState({species: result.sort((a, b) => a.name.localeCompare(b.name))});
        }, params);
    };

    loadCategories = (q = '') => {
        const {categories} = this.props;
        const params = this.prepareParams(this.state.resource);
        if (categories) {
            this.setState({categories});
        } else {
            this.props.actions.searchCategories(q, result => this.setState({categories: result}), params);
        }
    };
    loadTags = (q = '') => {
        const {tags} = this.props;
        const params = this.prepareParams(this.state.resource);
        if (tags) {
            this.setState({tags});
        } else {
            this.props.actions.searchTags(q, result => this.setState({tags: result}), params);
        }
    };

    loadLocations = (q = '') => {
        const {locations} = this.props;
        const params = this.prepareParams(this.state.resource);
        if (locations) {
            this.setState({locations});
        } else {
            this.props.actions.searchLocations(q, result => this.setState({locations: result}), params);
        }
    };

    loadCycles = (q = '') => {
        const {cycles} = this.props;
        const params = this.prepareParams(this.state.resource);
        if (cycles) {
            this.setState({cycles});
        } else {
            this.props.actions.searchAllowedCycles(q, result => this.setState({cycles: result}), params);
        }
    };

    setGradings = () => {
        const {gradings} = this.props;
        if (gradings) {
            this.setState({gradings});
        }
    };

    getMenuStyle = () => {
        const isMedium = window.innerWidth < MOBILE_SCREEN_WIDTH;
        return {
            width: '100%',
            backgroundColor: isMedium ? {backgroundColor: window.getComputedStyle(document.body, null).getPropertyValue('background-color')} : null,
        };
    };

    showFilters = () => {
        const {filter} = this.props;
        return window.innerWidth >= MEDIUM_SCREEN_WIDTH || filter;
    };

    setThicks = () => {
        const {itemsExist} = this.props;
        const {bundle_slider, resource} = this.state;
        this.props.actions.loadThicks(thicks => {
            if (thicks.length > 0)
                thicks.sort((a, b) => parseFloat(a.thickness) - parseFloat(b.thickness));
            const thickness = {
                min: thicks[0].thickness,
                max: thicks[thicks.length - 1].thickness,
            };
            this.setState({
                bundle_slider: itemsExist ? {...bundle_slider, thickness} : bundle_slider,
                thicks: thicks,
                resource: itemsExist ? {
                    ...resource,
                    thickness: {min: thickness.min, max: thickness.max},
                    actual_thickness: {min: thickness.min, max: thickness.max},
                } : resource,
            }, () => this.loadFilters());
        });
    };

    getItemLabel = type => {
        switch (type) {
            case 'slabs':
                return 'Slabs';
            case 'bundles':
                return 'Packs';
            case 'industrial_packs':
                return 'Industrial Packs';
            case 'industrial_packs_mass_timber':
                return 'Industrial Packs Mass Timber';
            case 'lumbers':
                return 'Boards And Beams';
            default:
                return '';
        }

    };

    loadFilters = () => {
        const {
            slab_slider,
            lumber_slider,
            bundle_slider,
            industrial_pack_slider,
            industrial_pack_mass_timber_slider,
            resource,
        } = this.state;
        const {filters, itemsExist} = this.props;
        const defaultItemType = this.setItemTypeOptions().find(it => it.value === this.props.settings.default_item_type.toLowerCase());
        const ItemType = filters.type ? {
            value: filters.type,
            label: this.getItemLabel(filters.type),
        } : defaultItemType;

        const previousFilters = filters;

        if (ItemType && itemsExist) {
            this.props.actions.loadFilters(ItemType.value, this.props.filter_id, filters => {
                let newSlider;
                if (ItemType.value === 'bundles') {
                    newSlider = {...bundle_slider, ...filters};
                    this.setState({
                        bundle_slider: newSlider,
                        resource: {
                            ...resource, ...this.prepareFiltersAfterReload(previousFilters),
                            item_type: ItemType,
                        },
                    });
                } else if (ItemType.value === 'industrial_packs') {
                    newSlider = {...industrial_pack_slider, ...filters};
                    this.setState({
                        industrial_pack_slider: newSlider,
                        resource: {
                            ...resource, ...this.prepareFiltersAfterReload(previousFilters),
                            item_type: ItemType,
                        },
                    });
                } else if (ItemType.value === 'industrial_packs_mass_timber') {
                    newSlider = {...industrial_pack_mass_timber_slider, ...filters};
                    this.setState({
                        industrial_pack_mass_timber_slider: newSlider,
                        resource: {
                            ...resource, ...this.prepareFiltersAfterReload(previousFilters),
                            item_type: ItemType,
                        },
                    });
                } else if (ItemType.value === 'lumbers') {
                    newSlider = {...lumber_slider, ...filters};
                    this.setState({
                        lumber_slider: newSlider,
                        resource: {
                            ...resource, ...this.prepareFiltersAfterReload(previousFilters),
                            item_type: ItemType,
                        },
                    });
                } else {
                    newSlider = {...slab_slider, ...filters};
                    this.setState({
                        slab_slider: newSlider,
                        resource: {
                            ...resource, ...this.prepareFiltersAfterReload(previousFilters),
                            item_type: ItemType,
                        },
                    });
                }
                this.setState({ready: true});
            });
        } else {
            this.setState({ready: true, resource: {...resource, item_type: ItemType}});
        }
    };

    prepareFiltersAfterReload = (previousFilters) => {
        const {resource} = this.state;
        return {
            price: previousFilters.price || resource.price,
            width_minimum: previousFilters.width_minimum || resource.width_minimum,
            width_maximum: previousFilters.width_maximum || resource.width_maximum,
            surfaced_thickness: previousFilters.surfaced_thickness || resource.surfaced_thickness,
            thickness: previousFilters.thickness || resource.thickness,
            actual_thickness: previousFilters.actual_thickness || resource.actual_thickness,
            length: previousFilters.length || resource.length,
            characters: previousFilters.characters || resource.characters,
            number: previousFilters.number || resource.number,
            categories: previousFilters.categories || resource.categories,
            locations: previousFilters.locations || resource.locations,
            species: previousFilters.trees || resource.species,
            cycles: previousFilters.cycles || resource.cycles,
            gradings: previousFilters.gradings || resource.gradings,
            tags: previousFilters.tags || resource.tags,
            avg_board_length: previousFilters.avg_board_length || resource.avg_board_length,
            board_length: previousFilters.board_length || resource.board_length,
            total_bf: previousFilters.total_bf || resource.total_bf,
            available_bf: previousFilters.available_bf || resource.available_bf,
        };
    };

    toggleAdvancedFilters = () => {
        const {advancedFilters} = this.state;
        this.setState({advancedFilters: !advancedFilters});
    };

    mapOptions = (options) => {
        return options.map(o => ({value: o.id, label: o.name}));
    };

    filterTrees = (species) => {
        const options = this.mapOptions(species);
        const {filteredTreesId} = this.props;

        const isLoaded = filteredTreesId && filteredTreesId.length > 0 && options.length > 0;
        if (!isLoaded) return options;

        return options.filter(o => filteredTreesId.includes(o.value));
    };

    onSliderValueChange = (value, fieldToUpdate) => {
        const {resource, reset} = this.state;
        if (reset) return;

        resource[fieldToUpdate].min = value.from;
        resource[fieldToUpdate].max = value.to;
        this.setState({resource: resource}, this.delayedSearch);
    };

    render() {
        let isMedium = window.innerWidth < MEDIUM_SCREEN_WIDTH;
        let isSmallMobile = window.innerWidth < SMALL_MOBILE_SCREEN_WIDTH;

        window.onresize = () => {
            this.setState({
                isMedium: window.innerWidth < MEDIUM_SCREEN_WIDTH,
                isSmallMobile: window.innerWidth < SMALL_MOBILE_SCREEN_WIDTH,
            });
        };
        const {
            resource,
            slab_slider,
            lumber_slider,
            bundle_slider,
            industrial_pack_slider,
            industrial_pack_mass_timber_slider,
            resetSliderTime,
            numbers,
            characters,
            species,
            categories,
            tags,
            locations,
            ready,
            advancedFilters,
            cycles,
            gradings,
        } = this.state;
        const {settings, loading, mobileIframeDisplay} = this.props;
        const backgroundColor = getBackgroundColor(settings.left_container_color);
        const isGradingEnabled = this.props.profile.feature_flags.find(ff => ff.name === 'Grading');
        const isIndustrialPackMassTimberEnabled = this.props.profile.feature_flags.find(ff => ff.name === 'Industrial Packs - Mass Timber');
        const color = reverseColor(backgroundColor);
        const itemType = resource.item_type.value;

        return <div
            className={`flying-menu ${loading && 'disabled'}`}
            style={this.getMenuStyle()}>

            {<Row id='filter-container' style={{display: this.showFilters() ? 'block' : 'none'}}>
                <Col
                    sm={12}
                    className={`${mobileIframeDisplay && mobileIframeDisplay() && 'pl-0'}`}
                    style={settings.sticky_header
                        ? {
                            zIndex: 9, top: 0,
                            paddingTop: '10px',
                            left: isMedium ? 0 : 'inherit',
                            right: isMedium ? 'inherit' : 0,
                            position: isSmallMobile ? 'sticky' : 'inherit',
                            backgroundColor, color,
                        }
                        : {
                            backgroundColor, color,
                        }}>
                    <div
                        className={`filter-container pr-4 ${mobileIframeDisplay && mobileIframeDisplay() ? 'pl-2' : 'pl-4'}`}>
                        {ready ? <div>
                            <FormGroup row>
                                <Col xs={12}>
                                    <Label>
                                        Item Type
                                    </Label>
                                </Col>
                                <Col xs={12}>
                                    <Select
                                        placeholder='Search by type'
                                        value={resource.item_type}
                                        styles={embFilterStyle}
                                        options={this.setItemTypeOptions(isIndustrialPackMassTimberEnabled)}
                                        onChange={value => {
                                            this.setState(({resource}) => ({
                                                    resource: {...resource, item_type: value},
                                                    ready: false,
                                                }),
                                                () => {
                                                    this.props.actions.loadFilters(value ? value.value : 'slabs', this.props.filter_id, filterRanges => {
                                                        let newSlider;
                                                        if (value.value === 'bundles') {
                                                            const {bundle_slider} = this.state;
                                                            newSlider = {...bundle_slider, ...filterRanges};
                                                            this.setState({bundle_slider: newSlider});
                                                        } else if (value.value === 'industrial_packs') {
                                                            const {industrial_pack_slider} = this.state;
                                                            newSlider = {...industrial_pack_slider, ...filterRanges};
                                                            this.setState({
                                                                industrial_pack_slider: newSlider,
                                                            });
                                                        } else if (value.value === 'industrial_packs_mass_timber') {
                                                            const {industrial_pack_mass_timber_slider} = this.state;
                                                            newSlider = {...industrial_pack_mass_timber_slider, ...filterRanges};
                                                            this.setState({
                                                                industrial_pack_mass_timber_slider: newSlider,
                                                            });
                                                        } else if (value.value === 'lumbers') {
                                                            const {lumber_slider} = this.state;
                                                            newSlider = {...lumber_slider, ...filterRanges};
                                                            this.setState({lumber_slider: newSlider});
                                                        } else {
                                                            const {slab_slider} = this.state;
                                                            newSlider = {...slab_slider, ...filterRanges};
                                                            this.setState({slab_slider: newSlider});
                                                        }

                                                        const initialFilters = {...this.getInitialResource(value.value), ...newSlider};
                                                        this.setState({
                                                            resource: {...resource, ...initialFilters},
                                                            filters: {...filterRanges, ...initialFilters},
                                                        });
                                                        this.props.onItemTypeChange({...initialFilters, ...newSlider}, () => this.setState({ready: true}));
                                                        this.loadNumbers();
                                                    });
                                                },
                                            );
                                        }}
                                        isDisabled={loading}
                                        closeMenuOnSelect={true}
                                    />
                                </Col>
                            </FormGroup>
                            <FormGroup row>
                                <Col xs={12}>
                                    <Label>
                                        Species
                                    </Label>
                                </Col>
                                <Col xs={12}>
                                    <Select
                                        placeholder='Select species'
                                        value={resource.species}
                                        styles={embFilterStyle}
                                        options={this.filterTrees(species)}
                                        onChange={value => this.setState(
                                            {resource: {...resource, species: value}},
                                            () => {
                                                this.loadNumbers();
                                                this.onFilterSelect('trees', value);
                                                this.onFilterSelect('species', value);
                                            },
                                        )}
                                        isClearable
                                        isMulti
                                        isDisabled={loading}
                                        closeMenuOnSelect={true}
                                    />
                                </Col>
                            </FormGroup>
                            {ready && itemType === 'slabs' && <FormGroup row>
                                <Col xs={12}>
                                    <Label className='slider-label'>
                                        Price
                                    </Label>
                                </Col>
                                <Col xs={12} className='mb-3'>
                                    <Slider
                                        id={1}
                                        resetTime={resetSliderTime}
                                        min={slab_slider.price.min}
                                        max={slab_slider.price.max}
                                        from={resource.price.min}
                                        to={resource.price.max}
                                        onChange={value => this.onSliderValueChange(value, 'price')}
                                    />
                                </Col>
                                <Col xs={12}>
                                    <Label className='slider-label'>
                                        Minimum Width
                                    </Label>
                                </Col>
                                <Col xs={12} className='mb-3'>
                                    <Slider
                                        id={2}
                                        resetTime={resetSliderTime}
                                        min={slab_slider.width_minimum.min}
                                        max={slab_slider.width_minimum.max}
                                        from={resource.width_minimum.min}
                                        to={resource.width_minimum.max}
                                        onChange={value => this.onSliderValueChange(value, 'width_minimum')}
                                    />
                                </Col>
                                <Col xs={12}>
                                    <Label className='slider-label'>
                                        Maximum Width
                                    </Label>
                                </Col>
                                <Col xs={12} className='mb-3'>
                                    <Slider
                                        id={3}
                                        resetTime={resetSliderTime}
                                        min={slab_slider.width_maximum.min}
                                        max={slab_slider.width_maximum.max}
                                        from={resource.width_maximum.min}
                                        to={resource.width_maximum.max}
                                        onChange={value => this.onSliderValueChange(value, 'width_maximum')}
                                    />
                                </Col>
                                <Col xs={12}>
                                    <Label className='slider-label'>
                                        Thickness
                                    </Label>
                                </Col>
                                <Col xs={12} className='mb-3'>
                                    <Slider
                                        id={4}
                                        resetTime={resetSliderTime}
                                        min={slab_slider.surfaced_thickness.min}
                                        max={slab_slider.surfaced_thickness.max}
                                        from={+resource.surfaced_thickness.min}
                                        to={+resource.surfaced_thickness.max}
                                        step={0.1}
                                        onChange={value => this.onSliderValueChange(value, 'surfaced_thickness')}
                                    />
                                </Col>
                                <Col xs={12}>
                                    <Label className='slider-label'>
                                        Length
                                    </Label>
                                </Col>
                                <Col xs={12} className='mb-3'>
                                    <Slider
                                        id={5}
                                        resetTime={resetSliderTime}
                                        min={slab_slider.length.min}
                                        max={slab_slider.length.max}
                                        from={resource.length.min}
                                        to={resource.length.max}
                                        onChange={value => this.onSliderValueChange(value, 'length')}
                                    />
                                </Col>
                            </FormGroup>}
                            {ready && itemType === 'lumbers' && <FormGroup row>
                                <Col xs={12}>
                                    <Label className='slider-label'>
                                        Price
                                    </Label>
                                </Col>
                                <Col xs={12} className='mb-3'>
                                    <Slider
                                        id={1}
                                        resetTime={resetSliderTime}
                                        min={lumber_slider.price.min}
                                        max={lumber_slider.price.max}
                                        from={resource.price.min}
                                        to={resource.price.max}
                                        onChange={value => this.onSliderValueChange(value, 'price')}
                                    />
                                </Col>
                                <Col xs={12}>
                                    <Label className='slider-label'>
                                        Width
                                    </Label>
                                </Col>
                                <Col xs={12} className='mb-3'>
                                    <Slider
                                        id={2}
                                        resetTime={resetSliderTime}
                                        min={lumber_slider.width.min}
                                        max={lumber_slider.width.max}
                                        from={resource.width.min}
                                        to={resource.width.max}
                                        onChange={value => this.onSliderValueChange(value, 'width')}
                                    />
                                </Col>
                                <Col xs={12}>
                                    <Label className='slider-label'>
                                        Thickness
                                    </Label>
                                </Col>
                                <Col xs={12} className='mb-3'>
                                    <Slider
                                        id={4}
                                        resetTime={resetSliderTime}
                                        min={lumber_slider.surfaced_thickness.min}
                                        max={lumber_slider.surfaced_thickness.max}
                                        from={+resource.surfaced_thickness.min}
                                        to={+resource.surfaced_thickness.max}
                                        step={0.1}
                                        onChange={value => this.onSliderValueChange(value, 'surfaced_thickness')}
                                    />
                                </Col>
                                <Col xs={12}>
                                    <Label className='slider-label'>
                                        Length
                                    </Label>
                                </Col>
                                <Col xs={12} className='mb-3'>
                                    <Slider
                                        id={5}
                                        resetTime={resetSliderTime}
                                        min={lumber_slider.length.min}
                                        max={lumber_slider.length.max}
                                        from={resource.length.min}
                                        to={resource.length.max}
                                        onChange={value => this.onSliderValueChange(value, 'length')}
                                    />
                                </Col>
                            </FormGroup>}
                            {ready && itemType === 'bundles' &&
                                <FormGroup row>
                                    <Col xs={12}>
                                        <Label className='slider-label'>
                                            Price
                                        </Label>
                                    </Col>
                                    <Col xs={12} className='mb-3'>
                                        <Slider
                                            id={1}
                                            resetTime={resetSliderTime}
                                            min={bundle_slider.price.min}
                                            max={bundle_slider.price.max}
                                            from={resource.price.min}
                                            to={resource.price.max}
                                            onChange={value => this.onSliderValueChange(value, 'price')}
                                        />
                                    </Col>
                                    <Col xs={12}>
                                        <Label className='slider-label'>
                                            Average Board Length
                                        </Label>
                                    </Col>
                                    <Col xs={12} className='mb-3'>
                                        <Slider
                                            id={2}
                                            resetTime={resetSliderTime}
                                            min={bundle_slider.avg_board_length.min}
                                            max={bundle_slider.avg_board_length.max}
                                            from={resource.avg_board_length.min}
                                            to={resource.avg_board_length.max}
                                            onChange={value => this.onSliderValueChange(value, 'avg_board_length')}
                                        />
                                    </Col>
                                    <Col xs={12}>
                                        <Label className='slider-label'>
                                            Thickness
                                        </Label>
                                    </Col>
                                    <Col xs={12} className='mb-3'>
                                        <Slider
                                            id={3}
                                            resetTime={resetSliderTime}
                                            min={bundle_slider.thickness.min}
                                            max={bundle_slider.thickness.max}
                                            from={resource.thickness.min}
                                            to={resource.thickness.max}
                                            onChange={value => this.onSliderValueChange(value, 'thickness')}
                                        />
                                    </Col>
                                    <Col xs={12}>
                                        <Label className='slider-label'>
                                            Total bf
                                        </Label>
                                    </Col>
                                    <Col xs={12} className='mb-3'>
                                        <Slider
                                            id={4}
                                            resetTime={resetSliderTime}
                                            min={bundle_slider.total_bf.min}
                                            max={bundle_slider.total_bf.max}
                                            from={resource.total_bf.min}
                                            to={resource.total_bf.max}
                                            onChange={value => this.onSliderValueChange(value, 'total_bf')}
                                        />
                                    </Col>
                                </FormGroup>}
                            {ready && itemType === 'industrial_packs' &&
                                <FormGroup row>
                                    <Col xs={12}>
                                        <Label className='slider-label'>
                                            Price
                                        </Label>
                                    </Col>
                                    <Col xs={12} className='mb-3'>
                                        <Slider
                                            id={1}
                                            resetTime={resetSliderTime}
                                            min={industrial_pack_slider.price.min}
                                            max={industrial_pack_slider.price.max}
                                            from={resource.price.min}
                                            to={resource.price.max}
                                            onChange={value => this.onSliderValueChange(value, 'price')}
                                        />
                                    </Col>
                                    <Col xs={12}>
                                        <Label className='slider-label'>
                                            Average Board Length
                                        </Label>
                                    </Col>
                                    <Col xs={12} className='mb-3'>
                                        <Slider
                                            id={2}
                                            resetTime={resetSliderTime}
                                            min={industrial_pack_slider.avg_board_length.min}
                                            max={industrial_pack_slider.avg_board_length.max}
                                            from={resource.avg_board_length.min}
                                            to={resource.avg_board_length.max}
                                            onChange={value => this.onSliderValueChange(value, 'avg_board_length')}
                                        />
                                    </Col>
                                    <Col xs={12}>
                                        <Label className='slider-label'>
                                            Thickness
                                        </Label>
                                    </Col>
                                    <Col xs={12} className='mb-3'>
                                        <Slider
                                            id={3}
                                            resetTime={resetSliderTime}
                                            min={industrial_pack_slider.thickness.min}
                                            max={industrial_pack_slider.thickness.max}
                                            from={resource.thickness.min}
                                            to={resource.thickness.max}
                                            onChange={value => this.onSliderValueChange(value, 'thickness')}
                                        />
                                    </Col>
                                    <Col xs={12}>
                                        <Label className='slider-label'>
                                            Total bf
                                        </Label>
                                    </Col>
                                    <Col xs={12} className='mb-3'>
                                        <Slider
                                            id={4}
                                            resetTime={resetSliderTime}
                                            min={industrial_pack_slider.available_bf.min}
                                            max={industrial_pack_slider.available_bf.max}
                                            from={resource.available_bf.min}
                                            to={resource.available_bf.max}
                                            onChange={value => this.onSliderValueChange(value, 'available_bf')}
                                        />
                                    </Col>
                                </FormGroup>}
                            {ready && itemType === 'industrial_packs_mass_timber' &&
                                <FormGroup row>
                                    <Col xs={12}>
                                        <Label className='slider-label'>
                                            Price
                                        </Label>
                                    </Col>
                                    <Col xs={12} className='mb-3'>
                                        <Slider
                                            id={1}
                                            resetTime={resetSliderTime}
                                            min={industrial_pack_mass_timber_slider.price.min}
                                            max={industrial_pack_mass_timber_slider.price.max}
                                            from={resource.price.min}
                                            to={resource.price.max}
                                            onChange={value => this.onSliderValueChange(value, 'price')}
                                        />
                                    </Col>
                                    <Col xs={12}>
                                        <Label className='slider-label'>
                                            Board Length
                                        </Label>
                                    </Col>
                                    <Col xs={12} className='mb-3'>
                                        <Slider
                                            id={2}
                                            resetTime={resetSliderTime}
                                            min={industrial_pack_mass_timber_slider.board_length.min}
                                            max={industrial_pack_mass_timber_slider.board_length.max}
                                            from={resource.board_length.min}
                                            to={resource.board_length.max}
                                            onChange={value => this.onSliderValueChange(value, 'board_length')}
                                        />
                                    </Col>
                                    <Col xs={12}>
                                        <Label className='slider-label'>
                                            Thickness
                                        </Label>
                                    </Col>
                                    <Col xs={12} className='mb-3'>
                                        <Slider
                                            id={3}
                                            resetTime={resetSliderTime}
                                            min={industrial_pack_mass_timber_slider.thickness.min}
                                            max={industrial_pack_mass_timber_slider.thickness.max}
                                            from={resource.thickness.min}
                                            to={resource.thickness.max}
                                            onChange={value => this.onSliderValueChange(value, 'thickness')}
                                        />
                                    </Col>
                                    <Col xs={12}>
                                        <Label className='slider-label'>
                                            Actual Thickness
                                        </Label>
                                    </Col>
                                    <Col xs={12} className='mb-3'>
                                        <Slider
                                            id={4}
                                            resetTime={resetSliderTime}
                                            min={industrial_pack_mass_timber_slider.actual_thickness.min}
                                            max={industrial_pack_mass_timber_slider.actual_thickness.max}
                                            from={resource.actual_thickness.min}
                                            to={resource.actual_thickness.max}
                                            onChange={value => this.onSliderValueChange(value, 'actual_thickness')}
                                        />
                                    </Col>
                                    <Col xs={12}>
                                        <Label className='slider-label'>
                                            Total bf
                                        </Label>
                                    </Col>
                                    <Col xs={12} className='mb-3'>
                                        <Slider
                                            id={5}
                                            resetTime={resetSliderTime}
                                            min={industrial_pack_mass_timber_slider.available_bf.min}
                                            max={industrial_pack_mass_timber_slider.available_bf.max}
                                            from={resource.available_bf.min}
                                            to={resource.available_bf.max}
                                            onChange={value => this.onSliderValueChange(value, 'available_bf')}
                                        />
                                    </Col>
                                </FormGroup>}
                            <FormGroup row>
                                <div
                                    className={'toggle-advanced-filters pt-2 m-auto mb-0'}
                                    onClick={() => this.toggleAdvancedFilters()}>
                                    {advancedFilters ? 'Hide Advanced Filters' : 'Show Advanced Filters'}
                                </div>
                            </FormGroup>
                            {advancedFilters && <div className='select-boxes'>
                                <FormGroup row>
                                    <Col xl={1}>
                                        <Label>
                                            SKU
                                        </Label>
                                    </Col>
                                    <Col xs={12}>
                                        <Select
                                            placeholder='Select SKU'
                                            value={resource.number}
                                            styles={embFilterStyle}
                                            options={this.mapOptions(_.orderBy(_.uniqBy(numbers, 'name'), 'name', 'asc'))}
                                            onChange={value => this.setState(
                                                {resource: {...resource, number: value}, numbers: []},
                                                () => this.onFilterSelect('number', value),
                                            )}
                                            ref={this.skuRef}
                                            menuPortalTarget={document.body}
                                            menuPosition='fixed'
                                            onInputChange={this.loadNumbers}
                                            isClearable
                                            isDisabled={loading}
                                            closeMenuOnSelect={true}
                                        />
                                    </Col>
                                </FormGroup>
                                <FormGroup row>
                                    <Col xs={12}>
                                        <Label>
                                            Characters
                                        </Label>
                                    </Col>
                                    <Col xs={12}>
                                        <Select
                                            placeholder='Select character'
                                            value={resource.characters}
                                            styles={embFilterStyle}
                                            ref={this.charactersRef}
                                            menuPortalTarget={document.body}
                                            menuPosition='fixed'
                                            options={this.mapOptions(characters)}
                                            onChange={value => this.setState(
                                                {resource: {...resource, characters: value}},
                                                this.onFilterSelect('characters', value),
                                            )}
                                            onInputChange={this.loadCharacters}
                                            isClearable
                                            isMulti
                                            isDisabled={loading}
                                            closeMenuOnSelect={true}
                                        />
                                    </Col>
                                </FormGroup>
                                {itemType === 'slabs' && <FormGroup row>
                                    <Col xs={12}>
                                        <Label>
                                            Category
                                        </Label>
                                    </Col>
                                    <Col xs={12}>
                                        <Select
                                            placeholder='Select category'
                                            value={resource.categories}
                                            styles={embFilterStyle}
                                            options={this.mapOptions(categories)}
                                            onChange={value => this.setState(
                                                {resource: {...resource, categories: value}},
                                                this.onFilterSelect('categories', value),
                                            )}
                                            ref={this.categoryRef}
                                            menuPortalTarget={document.body}
                                            menuPosition='fixed'
                                            onInputChange={this.loadCategories}
                                            isClearable
                                            isMulti
                                            isDisabled={loading}
                                            closeMenuOnSelect={true}
                                        />
                                    </Col>
                                </FormGroup>}
                                {settings.show_tags_filter && <FormGroup row>
                                    <Col xs={12}>
                                        <Label>Tags</Label>
                                    </Col>
                                    <Col xs={12}>
                                        <Select
                                            placeholder='Select tags'
                                            value={resource.tags}
                                            styles={embFilterStyle}
                                            options={this.mapOptions(tags)}
                                            onChange={value => this.setState(
                                                {resource: {...resource, tags: value}},
                                                this.onFilterSelect('tags', value),
                                            )}
                                            ref={this.categoryRef}
                                            menuPortalTarget={document.body}
                                            menuPosition='fixed'
                                            onInputChange={this.loadTags}
                                            isClearable
                                            isMulti
                                            isDisabled={loading}
                                            closeMenuOnSelect={true}
                                        />
                                    </Col>
                                </FormGroup>}
                                {settings.show_location_filter && <FormGroup row>
                                    <React.Fragment>
                                        <Col xs={12}>
                                            <Label>
                                                Locations
                                            </Label>
                                        </Col>
                                        <Col xs={12}>
                                            <Select
                                                placeholder='Select location'
                                                value={resource.locations}
                                                styles={embFilterStyle}
                                                options={this.mapOptions(locations)}
                                                ref={this.locationRef}
                                                menuPortalTarget={document.body}
                                                menuPosition='fixed'
                                                onChange={value => this.setState(
                                                    {resource: {...resource, locations: value}},
                                                    this.onFilterSelect('locations', value),
                                                )}
                                                onInputChange={this.loadLocations}
                                                isClearable
                                                isMulti
                                                isDisabled={loading}
                                                closeMenuOnSelect={true}
                                            />
                                        </Col>
                                    </React.Fragment>
                                </FormGroup>}
                                <FormGroup row>
                                    {settings.show_status_filter &&
                                        <React.Fragment>
                                            <Col xs={12}>
                                                <Label>Statuses</Label>
                                            </Col>
                                            <Col xs={12}>
                                                <Select
                                                    placeholder='Select status'
                                                    value={resource.cycles}
                                                    styles={embFilterStyle}
                                                    options={this.mapOptions(cycles)}
                                                    ref={this.statusRef}
                                                    menuPortalTarget={document.body}
                                                    menuPosition='fixed'
                                                    onChange={value => this.setState(
                                                        {resource: {...resource, cycles: value}},
                                                        this.onFilterSelect('cycles', value),
                                                    )}
                                                    onInputChange={this.loadCycles}
                                                    isClearable
                                                    isMulti
                                                    isDisabled={loading}
                                                    closeMenuOnSelect={true}
                                                />
                                            </Col>
                                        </React.Fragment>
                                    }
                                </FormGroup>
                                {['industrial_packs', 'industrial_packs_mass_timber'].includes(itemType) && isGradingEnabled &&
                                    <FormGroup row>
                                        <React.Fragment>
                                            <Col xs={12}>
                                                <Label>Gradings</Label>
                                            </Col>
                                            <Col xs={12}>
                                                <Select
                                                    isClearable isMulti
                                                    placeholder='Select grading'
                                                    value={resource.gradings}
                                                    styles={embFilterStyle}
                                                    options={this.mapOptions(gradings)}
                                                    ref={this.statusRef}
                                                    menuPortalTarget={document.body}
                                                    menuPosition='fixed'
                                                    onChange={value => this.setState(
                                                        {resource: {...resource, gradings: value}},
                                                        this.onFilterSelect('gradings', value),
                                                    )}
                                                    onInputChange={this.setGradings}
                                                    isDisabled={loading}
                                                    closeMenuOnSelect={true}
                                                />
                                            </Col>
                                        </React.Fragment>
                                    </FormGroup>}
                            </div>}
                            <FormGroup row className='filter-buttons-container pb-3'>
                                <Col>
                                    <Button
                                        size='sm' className='w-100 text-left'
                                        color='danger'
                                        onClick={this.resetFilters}>
                                        Reset Filters
                                    </Button>
                                </Col>
                            </FormGroup>
                        </div> : <div className='w-100 d-flex justify-content-center pt-5'>
                            <Spinner size='lg' animation='border' role='status'>
                                <span className='sr-only'>Loading...</span>
                            </Spinner>
                        </div>}
                    </div>
                </Col>
            </Row>}
        </div>;
    }
}

EmbFilters.contextTypes = {
    router: PropTypes.object,
};

EmbFilters.propTypes = {
    actions: PropTypes.object,
    history: PropTypes.object,
};

const mapStateToProps = ({appState}) => ({
    profile: appState.profile,
    claimedItems: appState.claimedItems,
});

const mapDispatchToProps = dispatch => ({
    actions: bindActionCreators(
        actions,
        dispatch),
});

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(EmbFilters);


// WEBPACK FOOTER //
// ./src/containers/embeddable/utils/EmbFilters.js